import './HelixLoader.css';

function HelixLoader({ size = 80, color = '#d1d5db', dotCount = 16, gap = 2 }) {
    const dotSize = Math.max(4, size * 0.08);
    const radius = size * 0.2;
    const speed = 1.8; // seconds per full cycle
    const stagger = speed / dotCount;

    const style = {
        width: size,
        height: size,
        '--helix-color': color,
        '--dot-size': `${dotSize}px`,
        '--radius': `${radius}px`,
        '--speed': `${speed}s`,
        '--bar-width': `${radius * 2}px`,
        '--helix-gap': `${gap}px`,
    };

    const dots = Array.from({ length: dotCount }, (_, i) => i);

    return (
        <div className="helix-loader" style={style}>
            <div className="helix-strand helix-strand-a">
                {dots.map(i => (
                    <div
                        key={i}
                        className="helix-dot"
                        style={{ '--delay': `${-i * stagger}s` }}
                    />
                ))}
            </div>
            <div className="helix-strand helix-strand-b">
                {dots.map(i => (
                    <div
                        key={i}
                        className="helix-dot"
                        style={{ '--delay': `${-i * stagger}s` }}
                    />
                ))}
            </div>
        </div>
    );
}

export default HelixLoader;
